import { Check, Close } from '@octanner/prism-icons';
import React from 'react';
import { IconWrapper } from './styles';
import MuiSwitch from '@mui/material/Switch';

type Size = 'small' | 'medium';

const usePixelSize = (size: Size) => {
  switch (size) {
    case 'small':
      return { width: 16, height: 16, fontSize: 10, margin: '0px' };
    case 'medium':
    default:
      return { width: 18, height: 18, fontSize: 12, margin: '1px 1px' };
  }
};

const Switch: React.FC<React.ComponentProps<typeof MuiSwitch>> = ({
  size = 'medium',
  ...props
}) => {
  const [focused, setFocused] = React.useState(false);
  const dimensions = usePixelSize(size);

  return (
    <MuiSwitch
      size={size}
      onFocusVisible={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      checkedIcon={
        <IconWrapper {...dimensions} focused={focused}>
          <Check />
        </IconWrapper>
      }
      icon={
        <IconWrapper {...dimensions} focused={focused}>
          <Close />
        </IconWrapper>
      }
      {...props}
    />
  );
};

export default Switch;
